export const enErrorsLocale = {
  not_found: 'Not Found',

  not_allowed_to_access_developer_mode: 'You are not allowed to access developer mode',
};
